import React from "react"
import {sendToServer} from "../BidibDataProvider";

import {MdOutlineSettingsEthernet} from "react-icons/md";
import {FaUsb} from "react-icons/fa";

import {PiPlugs, PiPlugsConnected} from "react-icons/pi";
import {TiDeleteOutline} from "react-icons/ti";
import {GrCycle} from "react-icons/gr";

import IconButton from './IconButton.tsx'

import './bidib.css';
import {BIDIB_LINK_DESCRIPTOR_ROLE_INTERFACE} from "./BidibMessages";
import {connect} from "react-redux";

const Record = ({connection, record}) => {

    const connection_peer = record?.device?.length ? record?.device : `${record?.ip}:${record?.port}`

    const icon = record?.contype === "serial" ? <FaUsb/> : <MdOutlineSettingsEthernet/>
    const connected = connection?.connected

    if (connected) {
        return null
    }

    const product = record?.product
    const user = record?.user
    const uidx = record?.uid

    function connectClick() {
        let cx = {
            cmd: "connect",
            uid: uidx
        }
        sendToServer(cx)
    }


    return (


        <div style={{
            padding: '10px',
            margin: '10px',
            border: '1px solid black',
            background: 'rgb(168,165,159)',
            borderRadius: '5px',
            color: 'rgb(27,35,54)',
        }}
        >

            <div style={{
                display: "flex",
            }}>


                <>
                    <div style={{
                        float: "left",
                        width: "90%",
                    }}>
                        <div>
                            <div style={{
                                fontWeight: 'bold',
                                marginRight: '5px',

                            }}>{icon}&nbsp;{product}</div>
                        </div>
                        <div style={{fontStyle: 'italic', marginRight: '5px', paddingTop: '3px'}}>{uidx}</div>
                        <div style={{fontStyle: 'italic', marginRight: '5px', paddingTop: '3px'}}>{user}</div>
                        <div style={{fontStyle: 'italic', marginRight: '5px', paddingTop: '3px'}}>{connection_peer}</div>
                    </div>

                    <div style={{
                        float: "right",
                        width: "10%",
                    }}>

                        {<IconButton iconOn={<PiPlugsConnected/>} iconOff={<PiPlugs/>} on={connected}
                                     callback={connectClick} title={connected ? 'disconnect' : 'connect'}/>}

                    </div>

                </>

            </div>
        </div>
    )
}

function mapStateToProps(state, other) {
    const rx = state.bidib.data.record.find(it => it.uid === other.uid);
    const ry = state.bidib.data.node.find(it => it.uid === other.uid);

    return {connection: ry, record: rx}
}

export default connect(mapStateToProps)(Record)
